/**
 * @generated SignedSource<<ebf9cb042dc8fce3e1939578e98c464b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TeachersDataTableFiltersQuery$variables = Record<PropertyKey, never>;
export type TeachersDataTableFiltersQuery$data = {
  readonly allRoles: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly classes: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly section: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type TeachersDataTableFiltersQuery = {
  response: TeachersDataTableFiltersQuery$data;
  variables: TeachersDataTableFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "ClassNodeConnection",
    "kind": "LinkedField",
    "name": "classes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClassNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "section",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "classes(first:100)"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RoleNodeConnection",
    "kind": "LinkedField",
    "name": "allRoles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RoleNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeachersDataTableFiltersQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TeachersDataTableFiltersQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "55fd05d553ebcdc433bd8b19602302ef",
    "id": null,
    "metadata": {},
    "name": "TeachersDataTableFiltersQuery",
    "operationKind": "query",
    "text": "query TeachersDataTableFiltersQuery {\n  classes(first: 100) {\n    nodes {\n      id\n      name\n      section\n    }\n  }\n  allRoles {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d5e4bc15190e33662a7433f21d7d1af";

export default node;
